export var ConflictAction;
(function (ConflictAction) {
    ConflictAction["ADD_PRODUCT"] = "addProduct";
    ConflictAction["ADD_PRODUCT_TO_TARGET"] = "addProductToProduct";
    ConflictAction["DELETE_ENTITY"] = "deleteEntity";
    ConflictAction["ADD_ENTITY_TO_TARGET"] = "addEntityToTarget";
})(ConflictAction || (ConflictAction = {}));
//# sourceMappingURL=ConflictResolver.js.map